
export const LOCAL = 'LOCAL';
export const SERVICE = 'SERVICE';
export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';